<template>
  <a
    :href="href || '#'"
    :target="external ? '_blank' : undefined"
    :rel="external ? 'noopener noreferrer' : undefined"
    class="block rounded-theme-md px-3 py-2 transition-colors hover:bg-theme-surface-raised focus:outline-none focus:shadow-theme-focus"
  >
    <div class="flex items-center gap-2 mb-0.5">
      <span
        v-if="category"
        class="inline-flex items-center text-[10px] font-medium uppercase tracking-wide text-theme-brand"
      >
        {{ category }}
      </span>
      <span v-if="timestampLabel" class="text-[10px] tabular-nums text-theme-text-muted">
        {{ timestampLabel }}
      </span>
    </div>
    <h4 class="line-clamp-2 text-sm font-medium leading-snug text-theme-text">
      {{ title }}
    </h4>
    <p v-if="source" class="mt-0.5 truncate text-xs text-theme-text-muted">
      {{ source }}
    </p>
  </a>
</template>

<script setup>
  /* eslint-disable no-undef */
  import { computed } from 'vue';

  const props = defineProps({
    title: { type: String, required: true },
    category: { type: String, default: '' },
    source: { type: String, default: '' },
    href: { type: String, default: '' },
    timestamp: { type: [String, Date, null], default: null },
    external: { type: Boolean, default: true },
  });

  const timestampLabel = computed(() => {
    if (!props.timestamp) return '';
    const d = new Date(props.timestamp);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  });
</script>
